module.exports = __webpack_public_path__ + "img/shangcheng.b8caf745.png";